import React, { PropTypes } from 'react'

import PromoCodeForm from '../promo-code-form'

const PromoCodeFormModal = ({ onCancelClick, onSubmit, initialValues }) => (
  <PromoCodeForm onCancelClick={onCancelClick} onSubmit={onSubmit} initialValues={initialValues} />
)

PromoCodeFormModal.propTypes = {
  onCancelClick: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
}

export default PromoCodeFormModal



/** WEBPACK FOOTER **
 ** ./src/components/promo-code-form-modal/promo-code-form-modal.js
 **/